import { engineComponent, NumberUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { WinAnimator } from "../GameComponents/WinAnimator";
import { Symbol } from "../GameComponents/Symbol";
import { Payline } from "../GameComponents/Payline";
import { Communication } from "neo-games";
import { ReelExtended } from "./ReelExtended";
import { Symbols } from "../GameComponents/Symbols";
import { Paylines } from "../GameComponents/Paylines";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ModuleManager } from "../Managers/ModuleManager";
import { CustomUtils } from "../Utils/CustomUtils";
import { PlayList } from "../Components/Sounds/PlayList";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimatorExtended extends WinAnimator {
    protected _reelsBg: SwitchElement;

    public initialize(
        symbols: Symbols,
        paylines?: Paylines,
        noWinSymbolsContainer?: ContainerElement,
        symbolsContainer?: ContainerElement,
        reelsBg?: SwitchElement,
    ): void {
        this._reelsBg = reelsBg;
        super.initialize(symbols, paylines, noWinSymbolsContainer, symbolsContainer);
    }

    //******************************************************************************************************************
    //  ON REEL STOPPED, SHOW SYMBOLS
    //******************************************************************************************************************

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        super.onReelStopped(reelsData, reelIndex);

        this.impact(reelIndex);
        this.tease(reelIndex);
    }

    protected impact(reelIndex: number): void {
        for (let i = 0; i < this.currentReels[reelIndex].symbols.length; i++) {
            const symbolId = this.currentReels[reelIndex].symbols[i];
            const symbol = this.currentSymbols[reelIndex][i];
            let canImpact = false;

            if (symbolId == CustomUtils.SymbolFs) {
                canImpact = this.canSymbolImpact(
                    reelIndex,
                    2,
                    3,
                    (symbolId: number) => symbolId == CustomUtils.SymbolFs,
                );

                if (canImpact) {
                    PlayList.play("SND_BaseScatterHit" + reelIndex);
                }
            } else if (symbolId == CustomUtils.SymbolBonus) {
                canImpact = this.canSymbolImpact(
                    reelIndex,
                    4,
                    3,
                    (symbolId: number) => symbolId == CustomUtils.SymbolBonus,
                );

                if (canImpact) {
                    PlayList.play("SND_BaseBonusHit" + reelIndex);
                }
            }

            if (canImpact) {
                symbol.goToCase("IMPACT");
            }
        }
    }

    protected canSymbolImpact(
        reelIndex: number,
        lastReelIndex: number,
        requiredCount: number,
        compareFunction: (symbolId: number) => boolean,
    ): boolean {
        let symbolCount = 0;

        for (let i = 0; i < reelIndex + 1; i++) {
            for (let j = 0; j < this.symbolCount; j++) {
                let symbolId = this.currentReels[i].symbols[j];

                if (compareFunction(symbolId)) {
                    symbolCount++;
                }
            }
        }

        if (symbolCount > 0) {
            if (symbolCount + (lastReelIndex - reelIndex) >= requiredCount) {
                return true;
            }
        }

        return false;
    }

    protected tease(reelIndex: number): void {
        let scatterCount = 0;
        let bonusCount = 0;

        if (ReelExtended.TeaseingSymbols.length > 0) {
            if (this._reelsBg != null && this._reelsBg.getCurrentCase() == "NORMAL") {
                this._reelsBg.goToCase("TEASE");
            }

            for (let i = 0; i <= reelIndex; i++) {
                for (let j = 0; j < this.symbolCount; j++) {
                    const symbol = this.currentSymbols[i][j];
                    const symbolId = symbol.id + 1;

                    if (symbolId == CustomUtils.SymbolFs) {
                        scatterCount++;
                    }

                    if (symbolId == CustomUtils.SymbolBonus) {
                        bonusCount++;
                    }

                    if (ReelExtended.TeaseingSymbols.indexOf(symbolId) > -1) {
                        if (i == reelIndex) {
                            symbol.goToCase("IMPACT_WITH_TEAS");
                        } else {
                            symbol.goToCase("TEAS");
                        }
                    } else {
                        let hasFs = ModuleManager.freespinsEnabled();
                        if (hasFs && symbolId == CustomUtils.SymbolBonus) {
                            continue;
                        }

                        this.noWinSymbolsContainer.addChild(symbol);
                    }
                }
            }
        }

        //if not enough special or fs symbols, set all symbols to normal
        if ((reelIndex == 2 && scatterCount < 3) || (reelIndex == 4 && bonusCount < 3 && scatterCount < 3)) {
            this.allSymbolsGoToReset();

            for (let i = 0; i <= reelIndex; i++) {
                this.reorderSymbols(i);
            }

            if (this._reelsBg != null && this._reelsBg.getCurrentCase() == "WIN") {
                this._reelsBg.goToCase("TO_NORMAL");
            }
        }
    }

    //******************************************************************************************************************
    //  SHOW WINS
    //******************************************************************************************************************

    protected showFirstWins(): void {
        this.allSymbolsGoToCase(Symbol.CaseNowin, true);
        this.allPaylinesGoToCase(Payline.CaseNowin);

        for (let i = 0; i < this.currentWins.length; i++) {
            this.winSymbolsGoToCase(i, Symbol.CaseWin, false);
            this.winPaylineGoToCase(i, Payline.CaseWin);
        }

        this.startAnimation();
    }

    private hasCashWin(): boolean {
        if (this.currentWins != null) {
            for (let i = 0; i < this.currentWins.length; i++) {
                if (this.currentWins[i].type == Communication.Game.WinType.Cash) {
                    return true;
                }
            }
        }

        return false;
    }

    //******************************************************************************************************************
    //  TIMER
    //******************************************************************************************************************

    protected startTimer(status: string, duration: number): void {
        this.stopTimer();
        super.startTimer(status, duration);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimatorExtended.ts
 **/